// TEMPLATE
export const TEMPLATE_PROVIDER_SYSTEM = "SYSTEM";
export const TEMPLATE_THUMB_MAX_HEIGHT = 430;
export const TEMPLATE_THUMB_MIN_HEIGHT = 70;
export const TEMPLATE_GROUP_BUSINESS_ESSENTIALS_ID = "5f7321d1ef8b4a9c3aa2463e";
export const TEMPLATE_GROUP_BUSINESS_ESSENTIALS_NAME = "Business Essentials";